// Maps backend ErrorCode (see backend ErrorCode enum) to the i18n key with the
// user-friendly message for that duplicate-entity error.
export const DUPLICATE_ERROR_CODES: Record<string, string> = {
  DUP_TENANT_NAME: 'errors.duplicate.tenant',
  DUP_ROLE_NAME: 'errors.duplicate.role',
  DUP_MATERIAL_NAME: 'errors.duplicate.material',
  DUP_MATERIAL_ARTICLE_NUMBER: 'errors.duplicate.materialArticleNumber',
  DUP_RESOURCE_TYPE_NAME: 'errors.duplicate.resourceType',
  DUP_RESOURCE_NAME: 'errors.duplicate.resource',
  DUP_SHIFT_TEMPLATE_NAME: 'errors.duplicate.shiftTemplate',
  DUP_ROUTING_NAME: 'errors.duplicate.routing',
  DUP_SETUP_TIME_NAME: 'errors.duplicate.setupTime',
  DUP_CAMPAIGN_SEQUENCE_NAME: 'errors.duplicate.campaignSequence',
};

export const NOT_NULL_ERROR_CODE = 'DB_004';
